// generated by the plop

import { PROGRESS_STATUSES } from 'symbols';

export interface AuthStateModel {
  loginStatus: PROGRESS_STATUSES;
  token: string;
  checkUserExistStatus: PROGRESS_STATUSES;
  isUserExist: boolean;
  checkTelegramBotExistStatus: PROGRESS_STATUSES;
  isTelegramBotExist: boolean;
  sendConfirmCodeStatus: PROGRESS_STATUSES;
  telegramBotLink: string;
  telegramBotListStatus: {[tel: string]: boolean};
  registrationToken: string;
}

export const AUTH_STATE_DEFAULT: AuthStateModel = {
  loginStatus: PROGRESS_STATUSES.NOT_INITIALIZED,
  token: null,
  checkUserExistStatus: PROGRESS_STATUSES.NOT_INITIALIZED,
  isUserExist: false,
  checkTelegramBotExistStatus: PROGRESS_STATUSES.NOT_INITIALIZED,
  isTelegramBotExist: false,
  sendConfirmCodeStatus: PROGRESS_STATUSES.NOT_INITIALIZED,
  telegramBotLink: null,
  telegramBotListStatus: {},
  registrationToken: null,
};
